/* 
Author:Lamiaa Moustafa
Desc: Reusable Textarea component 
*/

import React from 'react'
import styled from 'styled-components'

export const FormTextarea = (props) => {
    const {
        label,
        // defaultValue,
        onChange,
        // ref,
        maxLength,
        customStyle,
        isRequired,
      } = props.data;
  return (
    <>
    <label>{label}</label>
   <Textarea  maxLength={maxLength} onChange={onChange} customStyle={customStyle} isRequired={isRequired}/>
   </>
  )
}
 const Textarea = styled.textarea`
    width:60%;
  padding: 20px;
  margin: 10px 40px;
  min-height: 80px;
  border-color: var(--orange);
 `